import script from "./PageCapsuleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PageCapsuleDetail.vue?vue&type=script&setup=true&lang=js"

import "./PageCapsuleDetail.vue?vue&type=style&index=0&id=06f6f2e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f6f2e1"]])

export default __exports__